__turbopack_context__.v({
  "arrow": "ChangeLanguage-module__oIaKXa__arrow",
  "button": "ChangeLanguage-module__oIaKXa__button",
  "buttonActive": "ChangeLanguage-module__oIaKXa__buttonActive",
  "container": "ChangeLanguage-module__oIaKXa__container",
  "content": "ChangeLanguage-module__oIaKXa__content",
  "language": "ChangeLanguage-module__oIaKXa__language",
  "light": "ChangeLanguage-module__oIaKXa__light",
  "trigger": "ChangeLanguage-module__oIaKXa__trigger",
});
